import React from 'react';
export const HerbSprig = ({
  className = '',
  color = '#2F6B34',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-124" data-mp="3l3q73ts5yfky">
    <path d="M12 22v-7l-2-2" data-id="element-125" data-mp="3c3bjuovn2qet" />
    <path d="M12 15l2-2" data-id="element-126" data-mp="cqj7442paty9" />
    <path d="M10 13a3 3 0 0 1-3-3c0-2 2-3 2-3s1 2 1 4" data-id="element-127" data-mp="coq0upw02bqs" />
    <path d="M14 13a3 3 0 0 0 3-3c0-2-2-3-2-3s-1 2-1 4" data-id="element-128" data-mp="7r6airm128ih" />
    <path d="M12 11a3 3 0 0 1-3-3c0-2 2-3 2-3s1 2 1 4" data-id="element-129" data-mp="7rpsg8bogwwi" />
    <path d="M12 11a3 3 0 0 0 3-3c0-2-2-3-2-3s-1 2-1 4" data-id="element-130" data-mp="3otdqsp9dkxu" />
  </svg>;
export const MortarPestle = ({
  className = '',
  color = '#A88838',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-131" data-mp="2ogbphtarwclc">
    <path d="M7 10l-2 10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2l-2-10" data-id="element-132" data-mp="2dxaw2hpxck8g" />
    <path d="M4 10h16" data-id="element-133" data-mp="2iw4coj0icrcu" />
    <path d="M15 4l-4 6" data-id="element-134" data-mp="2iukxywui2od6" />
    <path d="M17 2l-2 2" data-id="element-135" data-mp="2itrvw96hkn1d" />
  </svg>;
export const LeafCluster = ({
  className = '',
  color = '#6FA524',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-136" data-mp="29td0ggzt5rk5">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-137" data-mp="1zz364trb2j6s" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-138" data-mp="1m3io00jei50f" />
  </svg>;
export const TinctureBottle = ({
  className = '',
  color = '#C9A961',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-139" data-mp="1h68xsio6tpbj">
    <path d="M10 2v3" data-id="element-140" data-mp="3e4g4vnfdwoxz" />
    <path d="M14 2v3" data-id="element-141" data-mp="3e46bdpv4rznj" />
    <path d="M8 5h8v3a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5z" data-id="element-142" data-mp="3e3odkostlddi" />
    <path d="M7 10h10v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V10z" data-id="element-143" data-mp="3a2kyw5midndv" />
    <path d="M12 12v6" data-id="element-144" data-mp="3549sk4vf9v0e" />
    <path d="M10 15l2-2 2 2" data-id="element-145" data-mp="354t7rdtou5aq" />
  </svg>;
// Aliases to keep the imports used in Hero and MethodOverview
export const FeatherQuill = HerbSprig;
export const Flame = MortarPestle;
export const MoonPhase = LeafCluster;
export const LotusBud = TinctureBottle;